import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  display: flex;

  > header {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    width: 100%;

    margin-bottom: 1rem;

    button {
      margin-left: 1rem;
    }
  }
`;
